
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/job-board/[companyName]",
      function () {
        return require("private-next-pages/job-board/[companyName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/job-board/[companyName]"])
      });
    }
  